import React from 'react';

const DownloadIcon = (): React.ReactElement => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10 14.1667V2.5" stroke="#00AFFF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M16.6673 17.5H3.33398" stroke="#00AFFF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M14.1681 10L10.0007 14.1675L5.83398 10"
      stroke="#00AFFF"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default DownloadIcon;
